module.exports = __webpack_public_path__ + "img/mickey83.721fabb8.jpg";